import React from 'react';
import './App.css';
import {Button, Col, Container, Row} from "react-bootstrap";
import BibtexField from "BibtexField";
import {ToastContainer} from "react-toastify";

function App() {
    const citation = `@inproceedings{dueck2025finding,
author = {Dück, Moritz and Holter, Steffen and Chan, Robin Shing Moon and Sevastjanova, Rita and El-Assady, Mennatallah},
title = {Finding Needles in Document Haystacks: Augmenting Serendipitous Claim Retrieval Workflows},
year = {2025},
publisher = {Association for Computing Machinery},
address = {New York, NY, USA},
booktitle = {Proceedings of the 2025 CHI Conference on Human Factors in Computing Systems},
series = {CHI '25}
}`;

    return (
        <div className="App">
            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            <Container fluid={"xl"}>
                <Row className="justify-content-md-center">
                    <Col xs={12} md={8} style={{backgroundColor: "#fff"}} className={"pt-4 pb-5"}>
                        <h2 className="mb-4 fw-bold">
                            Finding Needles in Document Haystacks:
                            <br />
                            Augmenting Serendipitous Claim Retrieval Workflows
                        </h2>
                        <Container className="mt-2 mb-4">
                            <Row>
                                <Col md={4}>
                                    <h4>Authors</h4>
                                    <p>
                                        Moritz Dück<sup>*</sup><br/>
                                        Steffen Holter<sup>*</sup><br/>
                                        Robin Chan<br/>
                                        Rita Sevastjanova<br/>
                                        Mennatallah El-Assady
                                    </p>
                                </Col>
                                <Col md={4}>
                                    <h4>Published</h4>
                                    <p>
                                        2025
                                    </p>
                                </Col>
                                <Col md={4}>
                                    <h4>Conference</h4>
                                    <p>
                                        Proceedings of the 2025 CHI Conference on Human Factors in Computing Systems
                                    </p>
                                </Col>
                            </Row>
                            <Row>
                                {/* <Col style={{fontSize: "0.8em"}}>
                                    <sup>1</sup>ETH Zürich, Switzerland&emsp;
                                </Col> */}
                            </Row>
                        </Container>
                        <Container className="mb-4">
                            <Row className="justify-content-md-center">
                                <Col md="auto" className={"mb-1"}>
                                    <Button href="https://dl.acm.org/doi/10.1145/3706598.3713715">Paper</Button>
                                </Col>
                                <Col md="auto" className={"mb-1"}>
                                    <Button href="https://www.youtube.com/watch?v=VLE5w0ZGclo">Video</Button>
                                </Col> 
                                <Col md="auto" className={"mb-1"}>
                                    <Button href="https://aian.ivia.ch/">Demo Med.</Button>
                                </Col>
                                <Col md="auto" className={"mb-1"}>
                                    <Button href="https://deba.ivia.ch/">Demo Pol.</Button>
                                </Col> 
                            </Row>
                        </Container>
                        <p className="mb-4">
                        Preliminary exploration of vast text corpora for generating and validating hypotheses, typical in academic inquiry, requires flexible navigation and rapid validation of claims. Navigating the corpus by titles, summaries, and abstracts might neglect information, whereas identifying the relevant context-specific claims through in-depth reading is unfeasible with rapidly increasing publication numbers. Our paper identifies three typical user pathways for hypothesis exploration and operationalizes sentence-based retrieval combined with effective contextualization and provenance tracking in a unified workflow. We contribute an interface that augments the previously laborious tasks of claim identification and consistency checking using NLP techniques while balancing user control and serendipity. Use cases, expert interviews, and a user study with 10 participants demonstrate how the proposed workflow enables users to traverse literature corpora in novel and efficient ways. For the evaluation, we instantiate the tool within two independent domains, providing novel insights into the analysis of political discourse and medical research.
                        </p>
                        {/* <Container className="mb-4">
                            <Row className="justify-content-md-center">
                                <Col md="auto" className={"mb-1"}>
                                    <Button href="https://dl.acm.org/doi/10.1145/3706598.3713715">Paper</Button>
                                </Col>
                                <Col md="auto" className={"mb-1"}>
                                    <Button href="https://www.youtube.com/watch?v=VLE5w0ZGclo">Video</Button>
                                </Col> 
                                <Col md="auto" className={"mb-1"}>
                                    <Button href="https://aian.ivia.ch/">Demo (Medical)</Button>
                                </Col>
                                <Col md="auto" className={"mb-1"}>
                                    <Button href="https://deba.ivia.ch/">Demo (Political)</Button>
                                </Col> 
                            </Row>
                        </Container> */}
                        {/* <div className="ratio ratio-16x9 mb-4">
                            <iframe title={"generAItor Demo Video"} className="embed-responsive-item"
                                    src="https://www.youtube.com/embed/MdABGrlQ684"
                                    allowFullScreen></iframe>
                        </div> */}
                        <div>
                            <BibtexField labelText={"Please use the following BibTeX entry to cite this work:"}>
                                {citation}
                            </BibtexField>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default App;
